import React, { Component } from "react";

export default class QuestionCreate extends Component {

  constructor(props) {
    super(props);
    this.state = {question: '', category: '', category_vs: '', active: false, categories: []};


    // Fast redirection?
    if(!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');
    // Bindings
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_URL + '/categories')
      .then( ( response ) => response.json() )
      .then( ( categories ) => {
        this.setState({ categories: categories });
      });
  }

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState(state);
  }

  onSubmit(event) {
    event.preventDefault();

    const formData = this.state;
    fetch(process.env.REACT_APP_API_URL + '/questions/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log('data', data);
      this.props.history.push('/questions');
    })
  }

  render() {

    const catOptions = this.state.categories.map((item, i) => (
        <option key={i} value={item._id}>
          { item.name }
        </option>
    ));

    return (
      <form id="new-form" className="form container" method="POST" onSubmit={ this.onSubmit }>
        <div className="form-group">
          <input name="question" className="form-control form-control-lg" onChange={ this.onChange } />
        </div>

        <div className="form-group">
          <label>Categor&iacute;a</label>
          <select name="category" className="form-control form-control-lg" onChange={ this.onChange }>
            <option value="">Seleccione</option>
            { catOptions }
          </select>
        </div>
        <div className="form-group">
          <label>Categor&iacute;a Versus</label>
          <select name="category_vs" className="form-control form-control-lg" onChange={ this.onChange }>
            <option value="">Seleccione</option>
            { catOptions }
          </select>
        </div>
        <div className="form-group">
          <div className="form-check">
            <label className="form-check-label">
              <input name="active" className="form-check-input" type="checkbox" onChange={ this.onChange } />
              Activa
            </label>
          </div>
        </div>

        <input type="submit" className="btn btn-primary" value="Submit" />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/QuestionCreate.jsx